import { Alert, Icon, Text } from '@/componentsV1/BaseComponents'
import { faComment } from '@fortawesome/pro-solid-svg-icons'
export interface BookkeeperNoteProps {
  note?: string
}
const BookkeeperNote = ({ note }: BookkeeperNoteProps) => {
  if (!note) return null

  return (
    <Alert
      type="warn"
      title="Note from Bookeeping Team"
      customIcon={<Icon icon={faComment} />}
    >
      <Text as="bodySm" textAlign="left" color="charcoal">
        &quot;{note}&quot;
      </Text>
    </Alert>
  )
}

export default BookkeeperNote
